import React from "react";
import { useIsInclude } from "src/router/RoutersCst";
import ProtectedRoute from "@components/ProtectedRoute";
import { LOType, PagesID } from "@utils/utilsConfigurations";

import Customers, {
  RedirectAddEditUser,
} from "@pages/Contents/Corporate/Customers";
import CustomFieldsForm from "@pages/Contents/Corporate/Customers/CustomFieldsForm";
import LOTableOverall from "@pages/Contents/Corporate/Catalog/OverallCatalog/LOTableOverall";
import EnrollHistory from "@pages/Contents/Corporate/Catalog/sharedComponents/EnrollHistory";
import Enrollments from "@pages/Contents/Corporate/Catalog/sharedComponents/EnrollmentsForm";
import LOSubscribedUsers from "@pages/Contents/Corporate/Catalog/sharedComponents/SubscribedUsers";
import LOReminderInitiatives from "@pages/Contents/Corporate/Catalog/sharedComponents/SolicitInitiatives";
import LOSolicitGroup from "@pages/Contents/Corporate/Catalog/sharedComponents/SolicitInitiatives/SolicitGroups";
import LOSolicitUser from "@pages/Contents/Corporate/Catalog/sharedComponents/SolicitInitiatives/SolicitUser";
import ChangeStatusCompletion from "@pages/Contents/Corporate/Catalog/OverallCatalog/ChangeStatus";
import MultiScormTable from "@pages/Contents/Corporate/Catalog/OverallCatalog/ChangeStatus/components/multiScormTable";

const useCorporateUser = () => {
  const { isInclude } = useIsInclude();

  return [
    {
      path: "users",
      children: [
        {
          index: true,
          path: "",
          element: (
            <ProtectedRoute isAllowed={isInclude("corporate&&corporate.users")}>
              <Customers />
            </ProtectedRoute>
          ),
        },
        {
          path: "edit/:idUser",
          element: (
            <ProtectedRoute
              isAllowed={isInclude("corporate&&usermgmt.users.add")}
            >
              <RedirectAddEditUser isAdd={false} />
            </ProtectedRoute>
          ),
        },
        {
          path: "add",
          element: (
            <ProtectedRoute
              isAllowed={isInclude("corporate&&usermgmt.users.add")}
            >
              <RedirectAddEditUser isAdd={true} />
            </ProtectedRoute>
          ),
        },
        {
          path: ":idUser/enrolled-to",
          children: [
            {
              path: "",
              element: (
                <ProtectedRoute
                  isAllowed={isInclude("corporate&&usermgmt.users.add")}
                >
                  <LOTableOverall type={"enrolled-to"} />
                </ProtectedRoute>
              ),
            },
            {
              path: ":idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/:activityType/change-status",
              element: (
                <ProtectedRoute
                  isAllowed={isInclude("corporate&&usermgmt.users.add")}
                >
                  <ChangeStatusCompletion />
                </ProtectedRoute>
              ),
            },
            {
              path: ":idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/:activityType/multi-scorm",
              children: [
                {
                  index: true,
                  path: "",
                  element: (
                    <ProtectedRoute
                      isAllowed={isInclude("corporate&&usermgmt.users.add")}
                    >
                      <MultiScormTable />
                    </ProtectedRoute>
                  ),
                },
                {
                  path: "change-status/:idSCORM",
                  element: (
                    <ProtectedRoute
                      isAllowed={isInclude("corporate&&usermgmt.users.add")}
                    >
                      <ChangeStatusCompletion />
                    </ProtectedRoute>
                  ),
                },
              ],
            },
            {
              path: ":idLO/:activityType/subscribed",
              children: [
                {
                  index: true,
                  path: "",
                  element: (
                    <ProtectedRoute
                      isAllowed={isInclude(
                        "corporate&&corporate.catalog&&learning.enrollment.read",
                      )}
                    >
                      <LOSubscribedUsers
                        showIssuedCertificates={true}
                        page={PagesID["corporate.catalog.path.subscribed"]}
                      />
                    </ProtectedRoute>
                  ),
                },
                {
                  path: ":userId/enrollment",
                  element: (
                    <ProtectedRoute
                      isAllowed={isInclude(
                        "corporate&&corporate.catalog&&learning.enrollment.read",
                      )}
                    >
                      <Enrollments />
                    </ProtectedRoute>
                  ),
                },
                {
                  path: ":groupType/:groupId/enrollment",
                  element: (
                    <ProtectedRoute
                      isAllowed={isInclude(
                        "corporate&&corporate.catalog&&learning.enrollment.read",
                      )}
                    >
                      <Enrollments />
                    </ProtectedRoute>
                  ),
                },
                {
                  path: ":userId/enrollment-history",
                  element: (
                    <ProtectedRoute
                      isAllowed={isInclude(
                        "corporate&&corporate.catalog&&learning.enrollment.read",
                      )}
                    >
                      <EnrollHistory />
                    </ProtectedRoute>
                  ),
                },
                {
                  path: "initiatives-solicit",
                  children: [
                    {
                      index: true,
                      path: "",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude(
                            "corporate&&corporate.catalog&&learning.enrollment.read",
                          )}
                        >
                          <LOReminderInitiatives
                            type={LOType.PATHS}
                            page={
                              PagesID[
                                "corporate.catalog.path.subscribed.initiatives-solicit"
                              ]
                            }
                          />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: ":idInitiative/groups",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude(
                            "corporate&&corporate.catalog&&learning.enrollment.read",
                          )}
                        >
                          <LOSolicitGroup
                            type={LOType.PATHS}
                            page={
                              PagesID[
                                "corporate.catalog.path.subscribed.initiatives-solicit.groups"
                              ]
                            }
                          />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: ":idInitiative/domain",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude(
                            "corporate&&corporate.catalog&&learning.enrollment.read",
                          )}
                        >
                          <LOSolicitUser
                            type={LOType.PATHS}
                            page={
                              PagesID[
                                "corporate.catalog.path.subscribed.initiatives-solicit.domain"
                              ]
                            }
                          />
                        </ProtectedRoute>
                      ),
                    },
                  ],
                },
                {
                  path: ":idUser/:idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/change-status",
                  element: (
                    <ProtectedRoute
                      isAllowed={isInclude("corporate&&usermgmt.users.add")}
                    >
                      <ChangeStatusCompletion />
                    </ProtectedRoute>
                  ),
                },
                {
                  path: ":idUser/:idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/multi-scorm",
                  children: [
                    {
                      index: true,
                      path: "",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude("corporate&&usermgmt.users.add")}
                        >
                          <MultiScormTable />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: "change-status/:idSCORM",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude("corporate&&usermgmt.users.add")}
                        >
                          <ChangeStatusCompletion />
                        </ProtectedRoute>
                      ),
                    },
                  ],
                },
              ],
            },
            {
              path: ":idPath/associated-los",
              children: [
                {
                  index: true,
                  path: "",
                  element: (
                    <ProtectedRoute isAllowed={isInclude("catalog")}>
                      <LOTableOverall type={"associated-los"} />
                    </ProtectedRoute>
                  ),
                },
                {
                  path: ":idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/:activityType/change-status",
                  element: (
                    <ProtectedRoute
                      isAllowed={isInclude("corporate&&usermgmt.users.add")}
                    >
                      <ChangeStatusCompletion />
                    </ProtectedRoute>
                  ),
                },
                {
                  path: ":idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/:activityType/multi-scorm",
                  children: [
                    {
                      index: true,
                      path: "",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude("corporate&&usermgmt.users.add")}
                        >
                          <MultiScormTable />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: "change-status/:idSCORM",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude("corporate&&usermgmt.users.add")}
                        >
                          <ChangeStatusCompletion />
                        </ProtectedRoute>
                      ),
                    },
                  ],
                },
                {
                  path: ":idLO/:activityType/subscribed",
                  children: [
                    {
                      index: true,
                      path: "",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude(
                            "corporate&&corporate.catalog&&learning.enrollment.read",
                          )}
                        >
                          <LOSubscribedUsers
                            showIssuedCertificates={true}
                            page={PagesID["corporate.catalog.path.subscribed"]}
                          />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: ":userId/enrollment",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude(
                            "corporate&&corporate.catalog&&learning.enrollment.read",
                          )}
                        >
                          <Enrollments />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: ":groupType/:groupId/enrollment",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude(
                            "corporate&&corporate.catalog&&learning.enrollment.read",
                          )}
                        >
                          <Enrollments />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: ":userId/enrollment-history",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude(
                            "corporate&&corporate.catalog&&learning.enrollment.read",
                          )}
                        >
                          <EnrollHistory />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: "initiatives-solicit",
                      children: [
                        {
                          index: true,
                          path: "",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&corporate.catalog&&learning.enrollment.read",
                              )}
                            >
                              <LOReminderInitiatives
                                type={LOType.PATHS}
                                page={
                                  PagesID[
                                    "corporate.catalog.path.subscribed.initiatives-solicit"
                                  ]
                                }
                              />
                            </ProtectedRoute>
                          ),
                        },
                        {
                          path: ":idInitiative/groups",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&corporate.catalog&&learning.enrollment.read",
                              )}
                            >
                              <LOSolicitGroup
                                type={LOType.PATHS}
                                page={
                                  PagesID[
                                    "corporate.catalog.path.subscribed.initiatives-solicit.groups"
                                  ]
                                }
                              />
                            </ProtectedRoute>
                          ),
                        },
                        {
                          path: ":idInitiative/domain",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&corporate.catalog&&learning.enrollment.read",
                              )}
                            >
                              <LOSolicitUser
                                type={LOType.PATHS}
                                page={
                                  PagesID[
                                    "corporate.catalog.path.subscribed.initiatives-solicit.domain"
                                  ]
                                }
                              />
                            </ProtectedRoute>
                          ),
                        },
                      ],
                    },
                    {
                      path: ":idUser/:idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/change-status",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude("corporate&&usermgmt.users.add")}
                        >
                          <ChangeStatusCompletion />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: ":idUser/:idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/multi-scorm",
                      children: [
                        {
                          index: true,
                          path: "",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&usermgmt.users.add",
                              )}
                            >
                              <MultiScormTable />
                            </ProtectedRoute>
                          ),
                        },
                        {
                          path: "change-status/:idSCORM",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&usermgmt.users.add",
                              )}
                            >
                              <ChangeStatusCompletion />
                            </ProtectedRoute>
                          ),
                        },
                      ],
                    },
                  ],
                },
                {
                  path: ":idCourse/associated-activities",
                  children: [
                    {
                      index: true,
                      path: "",
                      element: (
                        <ProtectedRoute isAllowed={isInclude("catalog")}>
                          <LOTableOverall type={"associated-activities"} />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: ":idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/:activityType/change-status",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude("corporate&&usermgmt.users.add")}
                        >
                          <ChangeStatusCompletion />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: ":idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/:activityType/multi-scorm",
                      children: [
                        {
                          index: true,
                          path: "",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&usermgmt.users.add",
                              )}
                            >
                              <MultiScormTable />
                            </ProtectedRoute>
                          ),
                        },
                        {
                          path: "change-status/:idSCORM",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&usermgmt.users.add",
                              )}
                            >
                              <ChangeStatusCompletion />
                            </ProtectedRoute>
                          ),
                        },
                      ],
                    },
                    {
                      path: ":idLO/:activityType/subscribed",
                      children: [
                        {
                          index: true,
                          path: "",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&corporate.catalog&&learning.enrollment.read",
                              )}
                            >
                              <LOSubscribedUsers
                                showIssuedCertificates={true}
                                page={
                                  PagesID["corporate.catalog.path.subscribed"]
                                }
                              />
                            </ProtectedRoute>
                          ),
                        },
                        {
                          path: ":userId/enrollment",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&corporate.catalog&&learning.enrollment.read",
                              )}
                            >
                              <Enrollments />
                            </ProtectedRoute>
                          ),
                        },
                        {
                          path: ":groupType/:groupId/enrollment",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&corporate.catalog&&learning.enrollment.read",
                              )}
                            >
                              <Enrollments />
                            </ProtectedRoute>
                          ),
                        },
                        {
                          path: ":userId/enrollment-history",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&corporate.catalog&&learning.enrollment.read",
                              )}
                            >
                              <EnrollHistory />
                            </ProtectedRoute>
                          ),
                        },
                        {
                          path: "initiatives-solicit",
                          children: [
                            {
                              index: true,
                              path: "",
                              element: (
                                <ProtectedRoute
                                  isAllowed={isInclude(
                                    "corporate&&corporate.catalog&&learning.enrollment.read",
                                  )}
                                >
                                  <LOReminderInitiatives
                                    type={LOType.PATHS}
                                    page={
                                      PagesID[
                                        "corporate.catalog.path.subscribed.initiatives-solicit"
                                      ]
                                    }
                                  />
                                </ProtectedRoute>
                              ),
                            },
                            {
                              path: ":idInitiative/groups",
                              element: (
                                <ProtectedRoute
                                  isAllowed={isInclude(
                                    "corporate&&corporate.catalog&&learning.enrollment.read",
                                  )}
                                >
                                  <LOSolicitGroup
                                    type={LOType.PATHS}
                                    page={
                                      PagesID[
                                        "corporate.catalog.path.subscribed.initiatives-solicit.groups"
                                      ]
                                    }
                                  />
                                </ProtectedRoute>
                              ),
                            },
                            {
                              path: ":idInitiative/domain",
                              element: (
                                <ProtectedRoute
                                  isAllowed={isInclude(
                                    "corporate&&corporate.catalog&&learning.enrollment.read",
                                  )}
                                >
                                  <LOSolicitUser
                                    type={LOType.PATHS}
                                    page={
                                      PagesID[
                                        "corporate.catalog.path.subscribed.initiatives-solicit.domain"
                                      ]
                                    }
                                  />
                                </ProtectedRoute>
                              ),
                            },
                          ],
                        },
                        {
                          path: ":idUser/:idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/change-status",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&usermgmt.users.add",
                              )}
                            >
                              <ChangeStatusCompletion />
                            </ProtectedRoute>
                          ),
                        },
                        {
                          path: ":idUser/:idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/multi-scorm",
                          children: [
                            {
                              index: true,
                              path: "",
                              element: (
                                <ProtectedRoute
                                  isAllowed={isInclude(
                                    "corporate&&usermgmt.users.add",
                                  )}
                                >
                                  <MultiScormTable />
                                </ProtectedRoute>
                              ),
                            },
                            {
                              path: "change-status/:idSCORM",
                              element: (
                                <ProtectedRoute
                                  isAllowed={isInclude(
                                    "corporate&&usermgmt.users.add",
                                  )}
                                >
                                  <ChangeStatusCompletion />
                                </ProtectedRoute>
                              ),
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: ":idCourse/associated-activities",
              children: [
                {
                  index: true,
                  path: "",
                  element: (
                    <ProtectedRoute isAllowed={isInclude("catalog")}>
                      <LOTableOverall type={"associated-activities"} />
                    </ProtectedRoute>
                  ),
                },
                {
                  path: ":idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/:activityType/change-status",
                  element: (
                    <ProtectedRoute
                      isAllowed={isInclude("corporate&&usermgmt.users.add")}
                    >
                      <ChangeStatusCompletion />
                    </ProtectedRoute>
                  ),
                },
                {
                  path: ":idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/:activityType/multi-scorm",
                  children: [
                    {
                      index: true,
                      path: "",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude("corporate&&usermgmt.users.add")}
                        >
                          <MultiScormTable />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: "change-status/:idSCORM",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude("corporate&&usermgmt.users.add")}
                        >
                          <ChangeStatusCompletion />
                        </ProtectedRoute>
                      ),
                    },
                  ],
                },
                {
                  path: ":idLO/:activityType/subscribed",
                  children: [
                    {
                      index: true,
                      path: "",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude(
                            "corporate&&corporate.catalog&&learning.enrollment.read",
                          )}
                        >
                          <LOSubscribedUsers
                            showIssuedCertificates={true}
                            page={PagesID["corporate.catalog.path.subscribed"]}
                          />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: ":userId/enrollment",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude(
                            "corporate&&corporate.catalog&&learning.enrollment.read",
                          )}
                        >
                          <Enrollments />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: ":groupType/:groupId/enrollment",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude(
                            "corporate&&corporate.catalog&&learning.enrollment.read",
                          )}
                        >
                          <Enrollments />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: ":userId/enrollment-history",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude(
                            "corporate&&corporate.catalog&&learning.enrollment.read",
                          )}
                        >
                          <EnrollHistory />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: "initiatives-solicit",
                      children: [
                        {
                          index: true,
                          path: "",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&corporate.catalog&&learning.enrollment.read",
                              )}
                            >
                              <LOReminderInitiatives
                                type={LOType.PATHS}
                                page={
                                  PagesID[
                                    "corporate.catalog.path.subscribed.initiatives-solicit"
                                  ]
                                }
                              />
                            </ProtectedRoute>
                          ),
                        },
                        {
                          path: ":idInitiative/groups",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&corporate.catalog&&learning.enrollment.read",
                              )}
                            >
                              <LOSolicitGroup
                                type={LOType.PATHS}
                                page={
                                  PagesID[
                                    "corporate.catalog.path.subscribed.initiatives-solicit.groups"
                                  ]
                                }
                              />
                            </ProtectedRoute>
                          ),
                        },
                        {
                          path: ":idInitiative/domain",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&corporate.catalog&&learning.enrollment.read",
                              )}
                            >
                              <LOSolicitUser
                                type={LOType.PATHS}
                                page={
                                  PagesID[
                                    "corporate.catalog.path.subscribed.initiatives-solicit.domain"
                                  ]
                                }
                              />
                            </ProtectedRoute>
                          ),
                        },
                      ],
                    },
                    {
                      path: ":idUser/:idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/change-status",
                      element: (
                        <ProtectedRoute
                          isAllowed={isInclude("corporate&&usermgmt.users.add")}
                        >
                          <ChangeStatusCompletion />
                        </ProtectedRoute>
                      ),
                    },
                    {
                      path: ":idUser/:idActivity/:learningObjectId/:parentActivityId/:grandparentActivityId/multi-scorm",
                      children: [
                        {
                          index: true,
                          path: "",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&usermgmt.users.add",
                              )}
                            >
                              <MultiScormTable />
                            </ProtectedRoute>
                          ),
                        },
                        {
                          path: "change-status/:idSCORM",
                          element: (
                            <ProtectedRoute
                              isAllowed={isInclude(
                                "corporate&&usermgmt.users.add",
                              )}
                            >
                              <ChangeStatusCompletion />
                            </ProtectedRoute>
                          ),
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: "users-custom-fields",
      loader: () => ({
        title: PagesID["corporate.customFields"],
      }),
      element: (
        <ProtectedRoute
          isAllowed={isInclude("usermgmt.corporates.custom_fields.read")}
        >
          <CustomFieldsForm />
        </ProtectedRoute>
      ),
    },
  ];
};

export default useCorporateUser;
